import isEmpty from 'lodash/isEmpty';
import { isValidPhoneNumber } from 'libphonenumber-js';
import i18n from '../../../i18n';

export const validate = values => {
    let errors = {};

    validateFirstName(values, errors);
    validateLastName(values, errors);
    validatePhoneNumber(values, errors);
    validatePassword(values, errors);
    validateCGV(values, errors);

    return errors;
};

export const validatePro = values => {
    let errors = {};

    validateAgencyName(values, errors);
    validateFirstName(values, errors);
    validateLastName(values, errors);
    validatePhoneNumber(values, errors);

    return errors;
};

const validateAgencyName = (values, errors) => {
    const value = values.agencyName;

    if (isEmpty(value)) {
        return errors.agencyName = i18n.t('account.validation_agency_name');
    }
};

const validateFirstName = (values, errors) => {
    const value = values.firstName;

    if (isEmpty(value)) {
        return errors.firstName = i18n.t('account.validation_first_name');
    }
};

const validateLastName = (values, errors) => {
    const value = values.lastName;

    if (isEmpty(value)) {
        return errors.lastName = i18n.t('account.validation_last_name');
    }
};

const validatePhoneNumber = (values, errors) => {
    const value = values.phoneNumber;

    if (!isEmpty(value) && !isValidPhoneNumber(value)) {
        return errors.phoneNumber = i18n.t('account.validation_phone_not_valid');
    }
    if(isEmpty(value)){
        return errors.phoneNumber = i18n.t('account.validation_phone');
    }
};

const validatePassword = (values, errors) => {
    const password = values.password;

    if (isEmpty(password)) {
        return errors.password = i18n.t('account.validation_password_will_be_needed');
    }
};

const validateCGV = (values, errors) => {
    const cgvChecked = values.cgv;

    if(cgvChecked !== true) {
        return errors.cgv = i18n.t('account.validation_cgv');
    }

}